module.exports = __webpack_public_path__ + "img/d0ecfd9.png";